export default ".status {\n  display: grid;\n  justify-items: center;\n}\n\n.status-name {\n  align-self: center;\n  padding: 12px;\n}";